import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/team-members/template/template-loading';

export const Route = createFileRoute('/_private/team-members/_template')({
  pendingComponent: TemplateLoading,
});
